var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"yield mx-3 pt-0"},[_c('bread-crumbs'),(_vm.showDashboard)?_c('report-list'):_c('v-row',{staticClass:"yield-report-content"},[_c('v-col',{staticClass:"yield-report"},[_c('data-table',{ref:"table",attrs:{"actions":_vm.actions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }